module.exports = __webpack_public_path__ + "media/images/voice08-da053051e4feac19a84fea5ae4936051.jpg";